import { useAtomValue } from "jotai";

import {
    type OrganizationsV2State,
    containersIndexV2Atom,
    defaultOrganizationContainerV2Atom,
    organizationsV2DataAtom,
    organizationsV2ErrorAtom,
    organizationsV2InitializedAtom,
    organizationsV2LoadingAtom,
    organizationsV2StateAtom,
} from "../../core/recoil/organizationsV2";
import { type ResourceContainer } from "../../gql-generated/types";

/**
 * Hook to get all OrganizationsV2 state (similar to useContext(OrganizationsContextV2))
 */
export const useOrganizationsV2 = (): OrganizationsV2State => {
    const state = useAtomValue(organizationsV2StateAtom);
    return state;
};

/**
 * Hook to get raw organizations data
 */
export const useOrganizationsV2Data = (): ResourceContainer[] => {
    return useAtomValue(organizationsV2DataAtom);
};

/**
 * Hook to get default organization container
 */
export const useDefaultOrganizationContainerV2 = (): ResourceContainer | undefined => {
    return useAtomValue(defaultOrganizationContainerV2Atom);
};

/**
 * Hook to get containers index map
 */
export const useContainersIndexV2 = (): Map<string, ResourceContainer> => {
    return useAtomValue(containersIndexV2Atom);
};

/**
 * Hook to get loading state
 */
export const useOrganizationsV2Loading = (): boolean => {
    return useAtomValue(organizationsV2LoadingAtom);
};

/**
 * Hook to get error state
 */
export const useOrganizationsV2Error = (): Error | undefined => {
    return useAtomValue(organizationsV2ErrorAtom);
};

/**
 * Hook to check if organizations V2 is initialized
 */
export const useOrganizationsV2Initialized = (): boolean => {
    return useAtomValue(organizationsV2InitializedAtom);
};
